import InputField from "../../../components/InputField";
import OptionalFields from "../../../components/OptionalFields";
import Toggle from "../../../components/Toggle";

export default function VanzatorStep({ data, errors, update }) {
  return (
    <div style={{ display: "flex", flexWrap: "wrap", gap: "16px" }}>
      <div style={{ width: "100%" }}>
        <Toggle
          label="Persoana juridica"
          description="Vanzatorul este o firma / societate comerciala"
          checked={!!data.vanzatorPJ}
          onChange={() => update("vanzatorPJ")(!data.vanzatorPJ)}
        />
      </div>

      {data.vanzatorPJ ? (
        <>
          <InputField label="Denumire societate" value={data.vanzatorFirma} onChange={update("vanzatorFirma")} placeholder="ex: SC Exemplu SRL" required error={errors.vanzatorFirma} />
          <InputField label="CUI" value={data.vanzatorCUI} onChange={update("vanzatorCUI")} placeholder="ex: RO12345678" required half error={errors.vanzatorCUI} />
          <InputField label="Nr. Reg. Comertului" value={data.vanzatorRegCom} onChange={update("vanzatorRegCom")} placeholder="ex: J40/1234/2020" half error={errors.vanzatorRegCom} />
          <InputField label="Sediu social" value={data.vanzatorSediu} onChange={update("vanzatorSediu")} placeholder="ex: Str. Exemplu nr. 1, Bucuresti" required error={errors.vanzatorSediu} />
          <InputField label="Reprezentant legal" value={data.vanzatorReprezentant} onChange={update("vanzatorReprezentant")} placeholder="ex: Popescu Ion" required error={errors.vanzatorReprezentant} />
        </>
      ) : (
        <>
          <InputField label="Nume complet" value={data.vanzatorNume} onChange={update("vanzatorNume")} placeholder="ex: Popescu Ion" required error={errors.vanzatorNume} />
          <InputField label="Adresa de domiciliu" value={data.vanzatorAdresa} onChange={update("vanzatorAdresa")} placeholder="ex: Str. Exemplu nr. 1, Bucuresti" required error={errors.vanzatorAdresa} />
          <OptionalFields>
            <InputField label="CNP" value={data.vanzatorCNP} onChange={update("vanzatorCNP")} placeholder="ex: 1234567890123" half error={errors.vanzatorCNP} helperText="Opțional — poți completa de mână pe document" />
            <InputField label="Serie si nr. CI" value={data.vanzatorCI} onChange={update("vanzatorCI")} placeholder="ex: RD 123456" half error={errors.vanzatorCI} helperText="Opțional — poți completa de mână pe document" />
          </OptionalFields>
        </>
      )}
    </div>
  );
}
